

import { X } from 'lucide-react';

const fmtARS = (n) => Number(n).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

const COLUMNAS = ['Código', 'Descripción', 'Cantidad', 'Precio', 'IVA', 'Importe', 'Dólar', 'Depósito'];

export default function DetalleMovStockPesificado({ detalleMovStock, onClose, mensajeError, movVenta }) {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

            <div className="relative z-10 w-full max-w-5xl bg-gray-900 border border-white/8 rounded-2xl overflow-hidden shadow-2xl"
                onClick={e => e.stopPropagation()}>

                {/* HEADER */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
                    <div>
                        <div className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.6em] mb-1">
                            Detalle comprobante
                        </div>
                        <p className="text-white font-black text-sm tracking-wide">
                            {movVenta?.Letrafactura ? movVenta?.Letrafactura + ' - ' : ''}
                            {movVenta?.Talonario} - {movVenta?.Nrocomprobante}
                            <span className="text-white/40 font-normal ml-2 text-xs">{movVenta?.Fecha}</span>
                        </p>
                        {movVenta?.Notamovimiento?.length > 0 && (
                            <p className="text-white/40 text-[11px] mt-1">Nota: {movVenta?.Notamovimiento}</p>
                        )}
                    </div>
                    <button onClick={onClose}
                        className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center text-white/30 hover:text-white hover:border-white/30 transition-all">
                        <X size={14} />
                    </button>
                </div>

                {/* TABLA */}
                <div className="overflow-auto max-h-80">
                    <table className="w-full border-collapse text-xs">
                        <thead>
                            <tr className="bg-gray-800 sticky top-0 z-10">
                                {COLUMNAS.map((col, i) => (
                                    <th key={i}
                                        className="px-3 py-2 border-r border-gray-700 text-white/70 font-bold uppercase tracking-wider whitespace-nowrap text-center last:border-r-0">
                                        {col}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {mensajeError ? (
                                <tr>
                                    <td colSpan="8" className="text-red-400 font-bold text-sm text-center py-8 bg-red-500/5">
                                        {mensajeError}
                                    </td>
                                </tr>
                            ) : (
                                detalleMovStock?.map((detalle, index) => (
                                    <tr key={index} className="bg-white/[0.02] hover:bg-white/[0.05] border-b border-white/5 transition-colors">
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-400 text-center font-mono">{detalle?.Codarticulo}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-white/80 text-left">{detalle?.Descarticulo}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-300 text-right font-mono">{detalle?.Cantidad}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-300 text-right font-mono">
                                            {fmtARS(detalle?.Precioarticulo * movVenta?.Cotizdolar)}
                                        </td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-400 text-right">{detalle?.Poriva}</td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-white font-black text-right font-mono">
                                            {fmtARS(detalle?.Importe * movVenta?.Cotizdolar)}
                                        </td>
                                        <td className="px-3 py-1.5 border-r border-white/5 text-gray-300 text-right font-mono">
                                            {movVenta?.Cotizdolar?.toFixed(4)}
                                        </td>
                                        <td className="px-3 py-1.5 text-gray-400 text-center">{detalle?.Coddeposito}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* FOOTER */}
                <div className="px-6 py-4 border-t border-white/5 flex justify-center">
                    <button onClick={onClose}
                        className="flex items-center gap-2 px-8 py-2.5 border border-white/10 hover:border-red-500/30 hover:bg-red-500/5 text-white/30 hover:text-red-400 text-[10px] font-black uppercase tracking-widest rounded-xl transition-all duration-300">
                        <X size={12} />
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}